import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport } from "vue"

import { onMounted, ref } from 'vue'
import { usePromisifyDialog } from '@shared/utils/dialog'
import FileProcessor from './FileProcessor.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  isShowPreviewFileComp: {
    type: Boolean,
    default: false,
  },
  previewFileInfo: {
    type: Object,
    default: function () {
      return {
      }
    },
  },
  callback: {
    type: Function,
    default: function () {
      return () => { }
    },
  },
},
  emits: ["dialog-close"],
  setup(__props, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {




const isMountedRef = ref(false)


const { close } = usePromisifyDialog(emit)

const handleClose = () => {
  isMountedRef.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

onMounted(async () => {
  console.log('mount')
  setTimeout(() => {
    isMountedRef.value = true
  }, 0)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (isMountedRef.value && __props.isShowPreviewFileComp)
      ? (_openBlock(), _createBlock(FileProcessor, {
          key: 0,
          onClose: handleClose,
          "preview-file-info": __props.previewFileInfo
        }, null, 8, ["preview-file-info"]))
      : _createCommentVNode("", true)
  ]))
}
}

})